export const GOVERNANCE_HUB_URL: string | undefined = process.env.REACT_APP_HUB_URL;
export const IPFS_GATEWAY: string | undefined = process.env.REACT_APP_IPFS_GATEWAY;
export const DEFAULT_SPACE: string = process.env.REACT_APP_DEFAULT_GOVERNANCE_SPACE ?? '';
